'use strict';

var _extends = require('../../../node_modules/@babel/runtime/helpers/extends.js');
var objectWithoutProperties = require('../../../node_modules/@babel/runtime/helpers/objectWithoutProperties.js');
var React = require('react');
var classNames = require('classnames');
var makeStyles = require('../../Styles/makeStyles.js');
var FilledFlatInput = require('./FilledFlatInput.js');
var FormControl = require('../../../node_modules/@material-ui/core/esm/FormControl/FormControl.js');
var InputLabel = require('../../../node_modules/@material-ui/core/esm/InputLabel/InputLabel.js');
var FormHelperText = require('../../../node_modules/@material-ui/core/esm/FormHelperText/FormHelperText.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var classNames__default = /*#__PURE__*/_interopDefaultLegacy(classNames);

var useStyles = makeStyles["default"]({
  root: {}
});
var FilledFlatTextField = React.forwardRef(function (_ref, ref) {
  var autoComplete = _ref.autoComplete,
      _ref$autoFocus = _ref.autoFocus,
      autoFocus = _ref$autoFocus === void 0 ? false : _ref$autoFocus,
      classes = _ref.classes,
      className = _ref.className,
      defaultValue = _ref.defaultValue,
      FormHelperTextProps = _ref.FormHelperTextProps,
      _ref$fullWidth = _ref.fullWidth,
      fullWidth = _ref$fullWidth === void 0 ? false : _ref$fullWidth,
      helperText = _ref.helperText,
      id = _ref.id,
      InputLabelProps = _ref.InputLabelProps,
      inputProps = _ref.inputProps,
      InputProps = _ref.InputProps,
      inputRef = _ref.inputRef,
      label = _ref.label,
      _ref$multiline = _ref.multiline,
      multiline = _ref$multiline === void 0 ? false : _ref$multiline,
      name = _ref.name,
      onBlur = _ref.onBlur,
      onChange = _ref.onChange,
      onFocus = _ref.onFocus,
      placeholder = _ref.placeholder,
      rows = _ref.rows,
      rowsMax = _ref.rowsMax,
      type = _ref.type,
      value = _ref.value,
      props = objectWithoutProperties(_ref, ["autoComplete", "autoFocus", "classes", "className", "defaultValue", "FormHelperTextProps", "fullWidth", "helperText", "id", "InputLabelProps", "inputProps", "InputProps", "inputRef", "label", "multiline", "name", "onBlur", "onChange", "onFocus", "placeholder", "rows", "rowsMax", "type", "value"]);

  var _useStyles = useStyles({
    classes: classes
  }),
      root = _useStyles.root;

  var helperTextId = helperText && id ? "".concat(id, "-helper-text") : undefined;
  var inputLabelId = label && id ? "".concat(id, "-label") : undefined;
  return React__default["default"].createElement(FormControl["default"], _extends["default"]({
    ref: ref,
    fullWidth: fullWidth,
    className: classNames__default["default"](root, className)
  }, props), label && React__default["default"].createElement(InputLabel["default"], _extends["default"]({
    id: inputLabelId
  }, InputLabelProps), label), React__default["default"].createElement(FilledFlatInput, _extends["default"]({
    "aria-describedby": helperTextId,
    autoComplete: autoComplete,
    autoFocus: autoFocus,
    defaultValue: defaultValue,
    fullWidth: fullWidth,
    multiline: multiline,
    name: name,
    rows: rows,
    rowsMax: rowsMax,
    type: type,
    value: value,
    id: id,
    inputRef: inputRef,
    onBlur: onBlur,
    onChange: onChange,
    onFocus: onFocus,
    placeholder: placeholder,
    inputProps: inputProps
  }, InputProps)), helperText && React__default["default"].createElement(FormHelperText["default"], _extends["default"]({
    id: helperTextId
  }, FormHelperTextProps), helperText));
});

module.exports = FilledFlatTextField;
